import type { ColophonContent } from "../i18n/types";

/*
 * Colophon — the quiet sign-off at the very end of the page.
 *
 * States who made this page and how: with UCloud AI, with love. Plain
 * facts, no virtue claimed — the fine print turns the platform's two core
 * promises back on the page itself, so the site ends by keeping the very
 * guarantees it makes.
 */
export function renderColophon(t: ColophonContent): HTMLElement {
  const root = document.createElement("footer");
  root.className = "colophon";
  root.innerHTML = `
    <div class="page">
      <p class="colophon__line">
        ${t.linePrefix} <span class="colophon__heart" aria-hidden="true">♥</span> ${t.lineSuffix}
      </p>
      <p class="colophon__fine">
        ${t.finePrint}
      </p>
    </div>
  `;
  return root;
}
